import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    loading: false,
    error: null,
    data: []
}

export const visitorSlice = createSlice({
    name: 'visitor',
    initialState,
    reducers: {
        getVisitors: () => { },
        removeVisitor: () => { },
        successVisitors: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        failedVisitors: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
    },
})

export const { getVisitors, removeVisitor, successVisitors, failedVisitors } = visitorSlice.actions

export default visitorSlice.reducer
